import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import Datepicker from 'components/ui/Datepicker';
import statusOptions from 'utils/BookingStatus';

const BookingToolbar = ({ 
  searchTerm, 
  onSearchChange,  
  statusFilter,
  onStatusFilterChange,
  onAddStaff, 
  selectedCount, 
  onBulkAction,
  totalCount,
  dateFilters,
  onDateFilterChange,
  refreshBookings
}) => {

  const bulkActions = [
    { value: 'activate', label: 'Activate Selected', icon: 'UserCheck' },
    { value: 'deactivate', label: 'Deactivate Selected', icon: 'UserX' },
    { value: 'delete', label: 'Delete Selected', icon: 'Trash2' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Main Toolbar Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        {/* Left Section - Search and Filters */}
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          {/* Search Input */}
          <div className="flex-1 max-w border border-1">
            <Input
              type="search"
              placeholder="Search by customer name, vehicle details..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>
       
          {/* Status Filter */}
          {/* <div className="w-full sm:w-48">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={onStatusFilterChange}
              placeholder="Filter by status"
            />
          </div>
          <div className="w-full sm:w-48">
            <Datepicker value={dateFilters.from} onChange={(val)=>onDateFilterChange('from',val)}/>
          </div>
          <div className="w-full sm:w-48">
            <Datepicker value={dateFilters.to} minDate={dateFilters.from} onChange={(val)=>onDateFilterChange('to',val)}/>
          </div>
          <div className='flex justify-center items-center cursor-pointer' title="Refresh Bookings" onClick={refreshBookings}>
            <Icon name="RefreshCcw" size={20} className="text-green-800  hover:text-green-700" />
          </div> */}
        </div>

        {/* Right Section - Add Button */}
        <div className="flex items-center gap-3">
          <Button
            variant="default"
            onClick={onAddStaff}
            iconName="Plus"
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap w-full md:w-auto"
          >
            Add New Booking
          </Button>
        </div>
      </div>

      <div className="flex md:flex-row flex-col gap-2 mb-2">
        <div className="w-full border border-1">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={onStatusFilterChange}
              placeholder="Filter by status"
            />
        </div>

        <div className="flex flex-col sm:flex-row gap-1 flex-1">
          <div className="w-full">
            <label htmlFor="date-from" className="block mb-1 sm:hidden">From</label>
            <Datepicker id="date-from" value={dateFilters.from} onChange={(val)=>onDateFilterChange('from',val)}/>
          </div>
          <div className="w-full">
            <label htmlFor="date-to" className="block mb-1 sm:hidden">To</label>
            <Datepicker id="date-to" value={dateFilters.to} minDate={dateFilters.from} onChange={(val)=>onDateFilterChange('to',val)}/>
          </div>
        </div>
        
        <Button iconName="RefreshCcw" iconSize={20} title="Refresh Bookings" onClick={refreshBookings}>
          {/* <Icon name="RefreshCcw" size={20} className="text-green-800  hover:text-green-700" /> */}
          Refresh
        </Button>
      </div>
      {/* Stats and Bulk Actions Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4 border-t border-border">
        {/* Stats */}
        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} />
            <span>Total: {totalCount}</span>
          </div>
          {selectedCount > 0 && (
            <div className="flex items-center gap-2 text-primary">
              <Icon name="CheckSquare" size={16} />
              <span>{selectedCount} selected</span>
            </div>
          )}
        </div>

        {/* Bulk Actions */}
        {selectedCount > 0 && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground mr-2">Bulk actions:</span>
            {bulkActions?.map((action) => (
              <Button
                key={action?.value}
                variant={action?.value === 'delete' ? 'destructive' : 'outline'}
                size="sm"
                onClick={() => onBulkAction(action?.value)}
                iconName={action?.icon}
                iconPosition="left"
                iconSize={14}
              >
                {action?.label}
              </Button>
            ))}
          </div>
        )}
      </div>
      {/* Mobile Bulk Actions */}
      {selectedCount > 0 && (
        <div className="sm:hidden mt-4 pt-4 border-t border-border">
          <div className="grid grid-cols-1 gap-2">
            {bulkActions?.map((action) => (
              <Button
                key={action?.value}
                variant={action?.value === 'delete' ? 'destructive' : 'outline'}
                size="sm"
                onClick={() => onBulkAction(action?.value)}
                iconName={action?.icon}
                iconPosition="left"
                iconSize={14}
                fullWidth
              >
                {action?.label}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingToolbar;